import { Component, OnInit, Input, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { Select } from '../../utilidades/utilidades';
import { FuncionService } from '../../servicios/funcion.service';
declare var $: any;

@Component({
	selector: 'app-select',
	templateUrl: './select.component.html',
	styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit {

	@Input() titulo:string;
	@Input() iniciar:boolean;
	@Output() newModelo = new EventEmitter<Select>();
	@Input() currentModelo:Select;
	@Input() listaElementos:Select[];
	@Input() search:boolean;

	txtBuscar:string = "";
	mostrarBuscador:boolean = true;
	
	constructor( private newFuncionService:FuncionService, @Inject(PLATFORM_ID) private platformId: Object ) {

	}

	ngOnInit() {
		this.mostrarBuscador = !this.search;
		setTimeout(()=>{
			if( this.listaElementos.length > 0 ){
				if( this.currentModelo ){
					if( this.currentModelo.id === 0 && this.iniciar === true ){
						this.currentModelo = this.listaElementos[0];
					}else{
						this.currentModelo = this.listaElementos.find( newItem => newItem.id === this.currentModelo.id);
					}
				}
			}
		},500);
	}

	fnAccionSimpleSelect( newEvent ){
		if (isPlatformBrowser(this.platformId)) {
			var newElemento = $(newEvent.target).parents(".simple-select").find(".simple-select-content");
			let currentState = $(newElemento).is(":visible");
			$(".simple-select-content").css({'display': 'none'});	
			$(newElemento).css({'display': (currentState)?'none':'block'});
			if( !currentState ){
				$(".txtbuscar").focus();
			}
		}
	}

	fnSeleccionItem( newModelo ){
		this.currentModelo = newModelo;
		this.newModelo.emit( this.currentModelo );
		if (isPlatformBrowser(this.platformId)) {
			$(".simple-select-content").css({'display': 'none'});	
		}
	}

	fnBorrarBusqueda(){
		if( this.txtBuscar !== "" ){
			this.txtBuscar = "";
		}
	}

	fnGetCaption(){
		if( this.currentModelo === undefined || this.currentModelo.id === 0 ){
			return this.titulo;
		}else{
			return this.currentModelo.nombre;
		}
	}

}
